import { hasInjectionContext as me, inject as Ee, effectScope as ve, ref as te, markRaw as I, toRaw as L, computed as ne, isRef as U, isReactive as z, toRef as M, getCurrentInstance as xe, reactive as ke, nextTick as ue, watch as ye, unref as Fe, getCurrentScope as He, onScopeDispose as Me, toRefs as le } from "vue";
import { setupDevtoolsPlugin as be } from "@vue/devtools-api";
/*!
 * pinia v3.0.1
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */
let R;
const F = (e) => R = e, pt = () => me() && Ee(oe) || R, oe = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function T(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var N;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(N || (N = {}));
const D = typeof window < "u", fe = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null };
function We(e, { autoBom: o = !1 } = {}) {
  return o && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\uFEFF", e], { type: e.type }) : e;
}
function se(e, o, n) {
  const t = new XMLHttpRequest();
  t.open("GET", e), t.responseType = "blob", t.onload = function() {
    Ne(t.response, o, n);
  }, t.onerror = function() {
    console.error("could not download file");
  }, t.send();
}
function Oe(e) {
  const o = new XMLHttpRequest();
  o.open("HEAD", e, !1);
  try {
    o.send();
  } catch {
  }
  return o.status >= 200 && o.status <= 299;
}
function W(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    const n = document.createEvent("MouseEvents");
    n.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(n);
  }
}
const G = typeof navigator == "object" ? navigator : { userAgent: "" }, Se = /Macintosh/.test(G.userAgent) && /AppleWebKit/.test(G.userAgent) && !/Safari/.test(G.userAgent), Ne = D ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !Se ? Ge : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in G ? Je : (
      // Fallback to using FileReader and a popup
      Be
    )
  )
) : () => {
};
function Ge(e, o = "download", n) {
  const t = document.createElement("a");
  t.download = o, t.rel = "noopener", typeof e == "string" ? (t.href = e, t.origin !== location.origin ? Oe(t.href) ? se(e, o, n) : (t.target = "_blank", W(t)) : W(t)) : (t.href = URL.createObjectURL(e), setTimeout(function() {
    URL.revokeObjectURL(t.href);
  }, 4e4), setTimeout(function() {
    W(t);
  }, 0));
}
function Je(e, o = "download", n) {
  if (typeof e == "string")
    if (Oe(e))
      se(e, o, n);
    else {
      const t = document.createElement("a");
      t.href = e, t.target = "_blank", setTimeout(function() {
        W(t);
      });
    }
  else
    navigator.msSaveOrOpenBlob(We(e, n), o);
}
function Be(e, o, n, t) {
  if (t = t || open("", "_blank"), t && (t.document.title = t.document.body.innerText = "downloading..."), typeof e == "string")
    return se(e, o, n);
  const s = e.type === "application/octet-stream", r = /constructor/i.test(String(fe.HTMLElement)) || "safari" in fe, i = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((i || s && r || Se) && typeof FileReader < "u") {
    const u = new FileReader();
    u.onloadend = function() {
      let f = u.result;
      if (typeof f != "string")
        throw t = null, new Error("Wrong reader.result type");
      f = i ? f : f.replace(/^data:[^;]*;/, "data:attachment/file;"), t ? t.location.href = f : location.assign(f), t = null;
    }, u.readAsDataURL(e);
  } else {
    const u = URL.createObjectURL(e);
    t ? t.location.assign(u) : location.href = u, t = null, setTimeout(function() {
      URL.revokeObjectURL(u);
    }, 4e4);
  }
}
function h(e, o) {
  const n = "🍍 " + e;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(n, o) : o === "error" ? console.error(n) : o === "warn" ? console.warn(n) : console.log(n);
}
function re(e) {
  return "_a" in e && "install" in e;
}
function we() {
  if (!("clipboard" in navigator))
    return h("Your browser doesn't support the Clipboard API", "error"), !0;
}
function $e(e) {
  return e instanceof Error && e.message.toLowerCase().includes("document is not focused") ? (h('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function Ye(e) {
  if (!we())
    try {
      await navigator.clipboard.writeText(JSON.stringify(e.state.value)), h("Global state copied to clipboard.");
    } catch (o) {
      if ($e(o))
        return;
      h("Failed to serialize the state. Check the console for more details.", "error"), console.error(o);
    }
}
async function ze(e) {
  if (!we())
    try {
      De(e, JSON.parse(await navigator.clipboard.readText())), h("Global state pasted from clipboard.");
    } catch (o) {
      if ($e(o))
        return;
      h("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(o);
    }
}
async function qe(e) {
  try {
    Ne(new Blob([JSON.stringify(e.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (o) {
    h("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(o);
  }
}
let w;
function Xe() {
  w || (w = document.createElement("input"), w.type = "file", w.accept = ".json");
  function e() {
    return new Promise((o, n) => {
      w.onchange = async () => {
        const t = w.files;
        if (!t)
          return o(null);
        const s = t.item(0);
        return o(s ? { text: await s.text(), file: s } : null);
      }, w.oncancel = () => o(null), w.onerror = n, w.click();
    });
  }
  return e;
}
async function Qe(e) {
  try {
    const n = await Xe()();
    if (!n)
      return;
    const { text: t, file: s } = n;
    De(e, JSON.parse(t)), h(`Global state imported from "${s.name}".`);
  } catch (o) {
    h("Failed to import the state from JSON. Check the console for more details.", "error"), console.error(o);
  }
}
function De(e, o) {
  for (const n in o) {
    const t = e.state.value[n];
    t ? Object.assign(t, o[n]) : e.state.value[n] = o[n];
  }
}
function b(e) {
  return {
    _custom: {
      display: e
    }
  };
}
const Ve = "🍍 Pinia (root)", J = "_root";
function Ze(e) {
  return re(e) ? {
    id: J,
    label: Ve
  } : {
    id: e.$id,
    label: e.$id
  };
}
function Ke(e) {
  if (re(e)) {
    const n = Array.from(e._s.keys()), t = e._s;
    return {
      state: n.map((r) => ({
        editable: !0,
        key: r,
        value: e.state.value[r]
      })),
      getters: n.filter((r) => t.get(r)._getters).map((r) => {
        const i = t.get(r);
        return {
          editable: !1,
          key: r,
          value: i._getters.reduce((u, f) => (u[f] = i[f], u), {})
        };
      })
    };
  }
  const o = {
    state: Object.keys(e.$state).map((n) => ({
      editable: !0,
      key: n,
      value: e.$state[n]
    }))
  };
  return e._getters && e._getters.length && (o.getters = e._getters.map((n) => ({
    editable: !1,
    key: n,
    value: e[n]
  }))), e._customProperties.size && (o.customProperties = Array.from(e._customProperties).map((n) => ({
    editable: !0,
    key: n,
    value: e[n]
  }))), o;
}
function et(e) {
  return e ? Array.isArray(e) ? e.reduce((o, n) => (o.keys.push(n.key), o.operations.push(n.type), o.oldValue[n.key] = n.oldValue, o.newValue[n.key] = n.newValue, o), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: b(e.type),
    key: b(e.key),
    oldValue: e.oldValue,
    newValue: e.newValue
  } : {};
}
function tt(e) {
  switch (e) {
    case N.direct:
      return "mutation";
    case N.patchFunction:
      return "$patch";
    case N.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let C = !0;
const B = [], P = "pinia:mutations", m = "pinia", { assign: nt } = Object, Y = (e) => "🍍 " + e;
function ot(e, o) {
  be({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: B,
    app: e
  }, (n) => {
    typeof n.now != "function" && h("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), n.addTimelineLayer({
      id: P,
      label: "Pinia 🍍",
      color: 15064968
    }), n.addInspector({
      id: m,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            Ye(o);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await ze(o), n.sendInspectorTree(m), n.sendInspectorState(m);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            qe(o);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await Qe(o), n.sendInspectorTree(m), n.sendInspectorState(m);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (t) => {
            const s = o._s.get(t);
            s ? typeof s.$reset != "function" ? h(`Cannot reset "${t}" store because it doesn't have a "$reset" method implemented.`, "warn") : (s.$reset(), h(`Store "${t}" reset.`)) : h(`Cannot reset "${t}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), n.on.inspectComponent((t) => {
      const s = t.componentInstance && t.componentInstance.proxy;
      if (s && s._pStores) {
        const r = t.componentInstance.proxy._pStores;
        Object.values(r).forEach((i) => {
          t.instanceData.state.push({
            type: Y(i.$id),
            key: "state",
            editable: !0,
            value: i._isOptionsAPI ? {
              _custom: {
                value: L(i.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => i.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(i.$state).reduce((u, f) => (u[f] = i.$state[f], u), {})
            )
          }), i._getters && i._getters.length && t.instanceData.state.push({
            type: Y(i.$id),
            key: "getters",
            editable: !1,
            value: i._getters.reduce((u, f) => {
              try {
                u[f] = i[f];
              } catch (d) {
                u[f] = d;
              }
              return u;
            }, {})
          });
        });
      }
    }), n.on.getInspectorTree((t) => {
      if (t.app === e && t.inspectorId === m) {
        let s = [o];
        s = s.concat(Array.from(o._s.values())), t.rootNodes = (t.filter ? s.filter((r) => "$id" in r ? r.$id.toLowerCase().includes(t.filter.toLowerCase()) : Ve.toLowerCase().includes(t.filter.toLowerCase())) : s).map(Ze);
      }
    }), globalThis.$pinia = o, n.on.getInspectorState((t) => {
      if (t.app === e && t.inspectorId === m) {
        const s = t.nodeId === J ? o : o._s.get(t.nodeId);
        if (!s)
          return;
        s && (t.nodeId !== J && (globalThis.$store = L(s)), t.state = Ke(s));
      }
    }), n.on.editInspectorState((t) => {
      if (t.app === e && t.inspectorId === m) {
        const s = t.nodeId === J ? o : o._s.get(t.nodeId);
        if (!s)
          return h(`store "${t.nodeId}" not found`, "error");
        const { path: r } = t;
        re(s) ? r.unshift("state") : (r.length !== 1 || !s._customProperties.has(r[0]) || r[0] in s.$state) && r.unshift("$state"), C = !1, t.set(s, r, t.state.value), C = !0;
      }
    }), n.on.editComponentState((t) => {
      if (t.type.startsWith("🍍")) {
        const s = t.type.replace(/^🍍\s*/, ""), r = o._s.get(s);
        if (!r)
          return h(`store "${s}" not found`, "error");
        const { path: i } = t;
        if (i[0] !== "state")
          return h(`Invalid path for store "${s}":
${i}
Only state can be modified.`);
        i[0] = "$state", C = !1, t.set(r, i, t.state.value), C = !0;
      }
    });
  });
}
function st(e, o) {
  B.includes(Y(o.$id)) || B.push(Y(o.$id)), be({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: B,
    app: e,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (n) => {
    const t = typeof n.now == "function" ? n.now.bind(n) : Date.now;
    o.$onAction(({ after: i, onError: u, name: f, args: d }) => {
      const _ = Pe++;
      n.addTimelineEvent({
        layerId: P,
        event: {
          time: t(),
          title: "🛫 " + f,
          subtitle: "start",
          data: {
            store: b(o.$id),
            action: b(f),
            args: d
          },
          groupId: _
        }
      }), i((g) => {
        V = void 0, n.addTimelineEvent({
          layerId: P,
          event: {
            time: t(),
            title: "🛬 " + f,
            subtitle: "end",
            data: {
              store: b(o.$id),
              action: b(f),
              args: d,
              result: g
            },
            groupId: _
          }
        });
      }), u((g) => {
        V = void 0, n.addTimelineEvent({
          layerId: P,
          event: {
            time: t(),
            logType: "error",
            title: "💥 " + f,
            subtitle: "end",
            data: {
              store: b(o.$id),
              action: b(f),
              args: d,
              error: g
            },
            groupId: _
          }
        });
      });
    }, !0), o._customProperties.forEach((i) => {
      ye(() => Fe(o[i]), (u, f) => {
        n.notifyComponentUpdate(), n.sendInspectorState(m), C && n.addTimelineEvent({
          layerId: P,
          event: {
            time: t(),
            title: "Change",
            subtitle: i,
            data: {
              newValue: u,
              oldValue: f
            },
            groupId: V
          }
        });
      }, { deep: !0 });
    }), o.$subscribe(({ events: i, type: u }, f) => {
      if (n.notifyComponentUpdate(), n.sendInspectorState(m), !C)
        return;
      const d = {
        time: t(),
        title: tt(u),
        data: nt({ store: b(o.$id) }, et(i)),
        groupId: V
      };
      u === N.patchFunction ? d.subtitle = "⤵️" : u === N.patchObject ? d.subtitle = "🧩" : i && !Array.isArray(i) && (d.subtitle = i.type), i && (d.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: i
        }
      }), n.addTimelineEvent({
        layerId: P,
        event: d
      });
    }, { detached: !0, flush: "sync" });
    const s = o._hotUpdate;
    o._hotUpdate = I((i) => {
      s(i), n.addTimelineEvent({
        layerId: P,
        event: {
          time: t(),
          title: "🔥 " + o.$id,
          subtitle: "HMR update",
          data: {
            store: b(o.$id),
            info: b("HMR update")
          }
        }
      }), n.notifyComponentUpdate(), n.sendInspectorTree(m), n.sendInspectorState(m);
    });
    const { $dispose: r } = o;
    o.$dispose = () => {
      r(), n.notifyComponentUpdate(), n.sendInspectorTree(m), n.sendInspectorState(m), n.getSettings().logStoreChanges && h(`Disposed "${o.$id}" store 🗑`);
    }, n.notifyComponentUpdate(), n.sendInspectorTree(m), n.sendInspectorState(m), n.getSettings().logStoreChanges && h(`"${o.$id}" store installed 🆕`);
  });
}
let Pe = 0, V;
function de(e, o, n) {
  const t = o.reduce((s, r) => (s[r] = L(e)[r], s), {});
  for (const s in t)
    e[s] = function() {
      const r = Pe, i = n ? new Proxy(e, {
        get(...f) {
          return V = r, Reflect.get(...f);
        },
        set(...f) {
          return V = r, Reflect.set(...f);
        }
      }) : e;
      V = r;
      const u = t[s].apply(i, arguments);
      return V = void 0, u;
    };
}
function rt({ app: e, store: o, options: n }) {
  if (!o.$id.startsWith("__hot:")) {
    if (o._isOptionsAPI = !!n.state, !o._p._testing) {
      de(o, Object.keys(n.actions), o._isOptionsAPI);
      const t = o._hotUpdate;
      L(o)._hotUpdate = function(s) {
        t.apply(this, arguments), de(o, Object.keys(s._hmrPayload.actions), !!o._isOptionsAPI);
      };
    }
    st(
      e,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      o
    );
  }
}
function _t() {
  const e = ve(!0), o = e.run(() => te({}));
  let n = [], t = [];
  const s = I({
    install(r) {
      F(s), s._a = r, r.provide(oe, s), r.config.globalProperties.$pinia = s, (process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__) && process.env.NODE_ENV !== "test" && D && ot(r, s), t.forEach((i) => n.push(i)), t = [];
    },
    use(r) {
      return this._a ? n.push(r) : t.push(r), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: o
  });
  return (process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__) && process.env.NODE_ENV !== "test" && D && typeof Proxy < "u" && s.use(rt), s;
}
function ht(e) {
  e._e.stop(), e._s.clear(), e._p.splice(0), e.state.value = {}, e._a = null;
}
const it = (e) => typeof e == "function" && typeof e.$id == "string";
function Ie(e, o) {
  for (const n in o) {
    const t = o[n];
    if (!(n in e))
      continue;
    const s = e[n];
    T(s) && T(t) && !U(t) && !z(t) ? e[n] = Ie(s, t) : e[n] = t;
  }
  return e;
}
function gt(e, o) {
  return process.env.NODE_ENV === "production" ? () => {
  } : (n) => {
    const t = o.data.pinia || e._pinia;
    if (t) {
      o.data.pinia = t;
      for (const s in n) {
        const r = n[s];
        if (it(r) && t._s.has(r.$id)) {
          const i = r.$id;
          if (i !== e.$id)
            return console.warn(`The id of the store changed from "${e.$id}" to "${i}". Reloading.`), o.invalidate();
          const u = t._s.get(i);
          if (!u) {
            console.log("[Pinia]: skipping hmr because store doesn't exist yet");
            return;
          }
          r(t, u);
        }
      }
    }
  };
}
const Te = () => {
};
function pe(e, o, n, t = Te) {
  e.push(o);
  const s = () => {
    const r = e.indexOf(o);
    r > -1 && (e.splice(r, 1), t());
  };
  return !n && He() && Me(s), s;
}
function j(e, ...o) {
  e.slice().forEach((n) => {
    n(...o);
  });
}
const ct = (e) => e(), _e = Symbol(), Z = Symbol();
function K(e, o) {
  e instanceof Map && o instanceof Map ? o.forEach((n, t) => e.set(t, n)) : e instanceof Set && o instanceof Set && o.forEach(e.add, e);
  for (const n in o) {
    if (!o.hasOwnProperty(n))
      continue;
    const t = o[n], s = e[n];
    T(s) && T(t) && e.hasOwnProperty(n) && !U(t) && !z(t) ? e[n] = K(s, t) : e[n] = t;
  }
  return e;
}
const Ae = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function mt(e) {
  return Object.defineProperty(e, Ae, {});
}
function at(e) {
  return !T(e) || !e.hasOwnProperty(Ae);
}
const { assign: y } = Object;
function he(e) {
  return !!(U(e) && e.effect);
}
function ge(e, o, n, t) {
  const { state: s, actions: r, getters: i } = o, u = n.state.value[e];
  let f;
  function d() {
    !u && (process.env.NODE_ENV === "production" || !t) && (n.state.value[e] = s ? s() : {});
    const _ = process.env.NODE_ENV !== "production" && t ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      le(te(s ? s() : {}).value)
    ) : le(n.state.value[e]);
    return y(_, r, Object.keys(i || {}).reduce((g, O) => (process.env.NODE_ENV !== "production" && O in _ && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${O}" in store "${e}".`), g[O] = I(ne(() => {
      F(n);
      const S = n._s.get(e);
      return i[O].call(S, S);
    })), g), {}));
  }
  return f = ee(e, d, o, n, t, !0), f;
}
function ee(e, o, n = {}, t, s, r) {
  let i;
  const u = y({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !t._e.active)
    throw new Error("Pinia destroyed");
  const f = { deep: !0 };
  process.env.NODE_ENV !== "production" && (f.onTrigger = (a) => {
    d ? S = a : d == !1 && !l._hotUpdating && (Array.isArray(S) ? S.push(a) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let d, _, g = [], O = [], S;
  const A = t.state.value[e];
  !r && !A && (process.env.NODE_ENV === "production" || !s) && (t.state.value[e] = {});
  const q = te({});
  let ie;
  function ce(a) {
    let c;
    d = _ = !1, process.env.NODE_ENV !== "production" && (S = []), typeof a == "function" ? (a(t.state.value[e]), c = {
      type: N.patchFunction,
      storeId: e,
      events: S
    }) : (K(t.state.value[e], a), c = {
      type: N.patchObject,
      payload: a,
      storeId: e,
      events: S
    });
    const p = ie = Symbol();
    ue().then(() => {
      ie === p && (d = !0);
    }), _ = !0, j(g, c, t.state.value[e]);
  }
  const Re = r ? function() {
    const { state: c } = n, p = c ? c() : {};
    this.$patch((E) => {
      y(E, p);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : Te
  );
  function Ce() {
    i.stop(), g = [], O = [], t._s.delete(e);
  }
  const X = (a, c = "") => {
    if (_e in a)
      return a[Z] = c, a;
    const p = function() {
      F(t);
      const E = Array.from(arguments), x = [], Q = [];
      function Le(v) {
        x.push(v);
      }
      function Ue(v) {
        Q.push(v);
      }
      j(O, {
        args: E,
        name: p[Z],
        store: l,
        after: Le,
        onError: Ue
      });
      let k;
      try {
        k = a.apply(this && this.$id === e ? this : l, E);
      } catch (v) {
        throw j(Q, v), v;
      }
      return k instanceof Promise ? k.then((v) => (j(x, v), v)).catch((v) => (j(Q, v), Promise.reject(v))) : (j(x, k), k);
    };
    return p[_e] = !0, p[Z] = c, p;
  }, H = /* @__PURE__ */ I({
    actions: {},
    getters: {},
    state: [],
    hotState: q
  }), ae = {
    _p: t,
    // _s: scope,
    $id: e,
    $onAction: pe.bind(null, O),
    $patch: ce,
    $reset: Re,
    $subscribe(a, c = {}) {
      const p = pe(g, a, c.detached, () => E()), E = i.run(() => ye(() => t.state.value[e], (x) => {
        (c.flush === "sync" ? _ : d) && a({
          storeId: e,
          type: N.direct,
          events: S
        }, x);
      }, y({}, f, c)));
      return p;
    },
    $dispose: Ce
  }, l = ke(process.env.NODE_ENV !== "production" || (process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__) && process.env.NODE_ENV !== "test" && D ? y(
    {
      _hmrPayload: H,
      _customProperties: I(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    ae
    // must be added later
    // setupStore
  ) : ae);
  t._s.set(e, l);
  const $ = (t._a && t._a.runWithContext || ct)(() => t._e.run(() => (i = ve()).run(() => o({ action: X }))));
  for (const a in $) {
    const c = $[a];
    if (U(c) && !he(c) || z(c))
      process.env.NODE_ENV !== "production" && s ? q.value[a] = M($, a) : r || (A && at(c) && (U(c) ? c.value = A[a] : K(c, A[a])), t.state.value[e][a] = c), process.env.NODE_ENV !== "production" && H.state.push(a);
    else if (typeof c == "function") {
      const p = process.env.NODE_ENV !== "production" && s ? c : X(c, a);
      $[a] = p, process.env.NODE_ENV !== "production" && (H.actions[a] = c), u.actions[a] = c;
    } else process.env.NODE_ENV !== "production" && he(c) && (H.getters[a] = r ? (
      // @ts-expect-error
      n.getters[a]
    ) : c, D && ($._getters || // @ts-expect-error: same
    ($._getters = I([]))).push(a));
  }
  if (y(l, $), y(L(l), $), Object.defineProperty(l, "$state", {
    get: () => process.env.NODE_ENV !== "production" && s ? q.value : t.state.value[e],
    set: (a) => {
      if (process.env.NODE_ENV !== "production" && s)
        throw new Error("cannot set hotState");
      ce((c) => {
        y(c, a);
      });
    }
  }), process.env.NODE_ENV !== "production" && (l._hotUpdate = I((a) => {
    l._hotUpdating = !0, a._hmrPayload.state.forEach((c) => {
      if (c in l.$state) {
        const p = a.$state[c], E = l.$state[c];
        typeof p == "object" && T(p) && T(E) ? Ie(p, E) : a.$state[c] = E;
      }
      l[c] = M(a.$state, c);
    }), Object.keys(l.$state).forEach((c) => {
      c in a.$state || delete l[c];
    }), d = !1, _ = !1, t.state.value[e] = M(a._hmrPayload, "hotState"), _ = !0, ue().then(() => {
      d = !0;
    });
    for (const c in a._hmrPayload.actions) {
      const p = a[c];
      l[c] = //
      X(p, c);
    }
    for (const c in a._hmrPayload.getters) {
      const p = a._hmrPayload.getters[c], E = r ? (
        // special handling of options api
        ne(() => (F(t), p.call(l, l)))
      ) : p;
      l[c] = //
      E;
    }
    Object.keys(l._hmrPayload.getters).forEach((c) => {
      c in a._hmrPayload.getters || delete l[c];
    }), Object.keys(l._hmrPayload.actions).forEach((c) => {
      c in a._hmrPayload.actions || delete l[c];
    }), l._hmrPayload = a._hmrPayload, l._getters = a._getters, l._hotUpdating = !1;
  })), (process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__) && process.env.NODE_ENV !== "test" && D) {
    const a = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((c) => {
      Object.defineProperty(l, c, y({ value: l[c] }, a));
    });
  }
  return t._p.forEach((a) => {
    if ((process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__) && process.env.NODE_ENV !== "test" && D) {
      const c = i.run(() => a({
        store: l,
        app: t._a,
        pinia: t,
        options: u
      }));
      Object.keys(c || {}).forEach((p) => l._customProperties.add(p)), y(l, c);
    } else
      y(l, i.run(() => a({
        store: l,
        app: t._a,
        pinia: t,
        options: u
      })));
  }), process.env.NODE_ENV !== "production" && l.$state && typeof l.$state == "object" && typeof l.$state.constructor == "function" && !l.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${l.$id}".`), A && r && n.hydrate && n.hydrate(l.$state, A), d = !0, _ = !0, l;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Et(e, o, n) {
  let t;
  const s = typeof o == "function";
  t = s ? n : o;
  function r(i, u) {
    const f = me();
    if (i = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && R && R._testing ? null : i) || (f ? Ee(oe, null) : null), i && F(i), process.env.NODE_ENV !== "production" && !R)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    i = R, i._s.has(e) || (s ? ee(e, o, t, i) : ge(e, t, i), process.env.NODE_ENV !== "production" && (r._pinia = i));
    const d = i._s.get(e);
    if (process.env.NODE_ENV !== "production" && u) {
      const _ = "__hot:" + e, g = s ? ee(_, o, t, i, !0) : ge(_, y({}, t), i, !0);
      u._hotUpdate(g), delete i.state.value[_], i._s.delete(_);
    }
    if (process.env.NODE_ENV !== "production" && D) {
      const _ = xe();
      if (_ && _.proxy && // avoid adding stores that are just built for hot module replacement
      !u) {
        const g = _.proxy, O = "_pStores" in g ? g._pStores : g._pStores = {};
        O[e] = d;
      }
    }
    return d;
  }
  return r.$id = e, r;
}
let je = "Store";
function vt(e) {
  je = e;
}
function yt(...e) {
  return process.env.NODE_ENV !== "production" && Array.isArray(e[0]) && (console.warn(`[🍍]: Directly pass all stores to "mapStores()" without putting them in an array:
Replace
	mapStores([useAuthStore, useCartStore])
with
	mapStores(useAuthStore, useCartStore)
This will fail in production if not fixed.`), e = e[0]), e.reduce((o, n) => (o[n.$id + je] = function() {
    return n(this.$pinia);
  }, o), {});
}
function ut(e, o) {
  return Array.isArray(o) ? o.reduce((n, t) => (n[t] = function() {
    return e(this.$pinia)[t];
  }, n), {}) : Object.keys(o).reduce((n, t) => (n[t] = function() {
    const s = e(this.$pinia), r = o[t];
    return typeof r == "function" ? r.call(this, s) : (
      // @ts-expect-error: FIXME: should work?
      s[r]
    );
  }, n), {});
}
const bt = ut;
function Ot(e, o) {
  return Array.isArray(o) ? o.reduce((n, t) => (n[t] = function(...s) {
    return e(this.$pinia)[t](...s);
  }, n), {}) : Object.keys(o).reduce((n, t) => (n[t] = function(...s) {
    return e(this.$pinia)[o[t]](...s);
  }, n), {});
}
function St(e, o) {
  return Array.isArray(o) ? o.reduce((n, t) => (n[t] = {
    get() {
      return e(this.$pinia)[t];
    },
    set(s) {
      return e(this.$pinia)[t] = s;
    }
  }, n), {}) : Object.keys(o).reduce((n, t) => (n[t] = {
    get() {
      return e(this.$pinia)[o[t]];
    },
    set(s) {
      return e(this.$pinia)[o[t]] = s;
    }
  }, n), {});
}
function Nt(e) {
  const o = L(e), n = {};
  for (const t in o) {
    const s = o[t];
    s.effect ? n[t] = // ...
    ne({
      get: () => e[t],
      set(r) {
        e[t] = r;
      }
    }) : (U(s) || z(s)) && (n[t] = // ---
    M(e, t));
  }
  return n;
}
export {
  N as MutationType,
  gt as acceptHMRUpdate,
  _t as createPinia,
  Et as defineStore,
  ht as disposePinia,
  pt as getActivePinia,
  Ot as mapActions,
  bt as mapGetters,
  ut as mapState,
  yt as mapStores,
  St as mapWritableState,
  F as setActivePinia,
  vt as setMapStoreSuffix,
  at as shouldHydrate,
  mt as skipHydrate,
  Nt as storeToRefs
};
